const apiurl="https://gy4fnmdyrb.execute-api.us-east-1.amazonaws.com/prod/";

export default apiurl;
